import CigeFi from '../../components/cigefi/cigefi';

const CigeFiPage = () => {
  return <CigeFi />;
};

export default CigeFiPage;
